import { useState } from 'react';
import Box from '@mui/material/Box';
import { hueFromString } from '../lib/format.js';
import { IconMusic } from './icons.jsx';

const SIZES = { sm: 36, md: 44, lg: 72 };

/**
 * Caratula de pista con fallback determinista (gradiente por hue del titulo)
 * si falta la miniatura o la imagen falla.
 */
export default function TrackCover({ src, alt, size = 'md', className = '', sx }) {
  const [failed, setFailed] = useState(false);
  const px = SIZES[size] ?? SIZES.md;
  const hue = hueFromString(alt ?? '');

  return (
    <Box
      className={className}
      sx={{
        width: px,
        height: px,
        flex: '0 0 auto',
        borderRadius: size === 'lg' ? '20px' : '12px',
        overflow: 'hidden',
        display: 'grid',
        placeItems: 'center',
        color: 'text.secondary',
        background: `linear-gradient(135deg, hsl(${hue} 45% 32%), hsl(${(hue + 40) % 360} 40% 18%))`,
        ...sx,
      }}
    >
      {src && !failed ? (
        <Box
          component="img"
          src={src}
          alt={alt ?? ''}
          loading="lazy"
          draggable={false}
          onError={() => setFailed(true)}
          sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
      ) : (
        <IconMusic size={size === 'lg' ? 30 : 18} />
      )}
    </Box>
  );
}
